import React from "react";
import { Button } from "../../ui/button";

export default function UploadCsvModal({
  open,
  fileName,
  recipientCount,
  error,
  warning,
  onClose,
}) {
  if (!open) return null;

  const hasError = !!error && recipientCount === 0;
  const hasRecipients = recipientCount > 0;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="rounded-lg shadow-lg w-[90%] max-w-md p-6 bg-card text-card-foreground"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-2 text-lg font-semibold">Upload CSV</div>
        {hasError ? (
          <div className="mb-6 text-sm text-destructive">{error}</div>
        ) : (
          <div className="mb-6 space-y-1">
            <p className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">{fileName}</span>
            </p>
            <p className="text-sm text-green-600 dark:text-green-500">
              {recipientCount} recipient{recipientCount !== 1 ? "s" : ""} loaded
            </p>
            {warning && (
              <p className="text-sm text-amber-600 dark:text-amber-500">{warning}</p>
            )}
          </div>
        )}
        <div className="flex justify-end">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
